<template>
  <div class="home">
    <v-layout row wrap justify-center class="mt-5">
      <h1 class="heading" style="color: #6B3689">{{ pageTitle }}</h1>
    </v-layout>

    <masonry
      :cols="{default: 4, 1000: 3, 850: 2, 600: 1}"
      :gutter="{default: '0px'}"
      >
      <card v-for="(post, index) in posts" :key="post.id" :post="post" :rank="index"/>
    </masonry>
  </div>
</template>

<script>
import Card from '@/components/Card'
export default {
  name: 'Home',
  components: {
    Card
  },
  data () {
    return {
      pageTitle: 'Galerie'
    }
  },
  computed: {
    posts () {
      return this.$store.getters.getPosts
    }
  }
}
</script>

<style>
.v-card__text, .v-card__title {
  word-break: normal !important;
}
</style>
